module.exports = __webpack_public_path__ + "img/apps_16.f790881c.jpg";